import { ShiftDetailActivity } from '../api/types';

import Avatar from './Avatar';

// One row of the shift activity feed. Shared by the Shift Detail panel's
// Recent activity preview and the "View all" modal (GRAVY-10294) — the modal is
// opened from the preview, so a row that changed shape on the way in would read
// as a different event.

export const relativeDay = (iso?: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  const today = new Date();
  const isSameDay = d.toDateString() === today.toDateString();
  if (isSameDay) return 'Today';
  const yest = new Date(today);
  yest.setDate(today.getDate() - 1);
  if (d.toDateString() === yest.toDateString()) return 'Yesterday';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  }).format(d);
};

// Full timestamp for the row's tooltip. "Today"/"Yesterday" is the right
// density for the list, but the exact moment still has to be recoverable when
// an admin is reconstructing what happened on a shift.
const exactTime = (iso?: string | null): string | undefined => {
  if (!iso) return undefined;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return undefined;
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
};

const ActivityItem = ({ item }: { item: ShiftDetailActivity }) => (
  <div className="dashv2-panel-actitem">
    <div className="dashv2-panel-actrow">
      <Avatar name={item.title} src={item.avatar_url} />
      <span className="dashv2-panel-acttext">
        {item.title || item.event_type}
      </span>
    </div>
    <div className="dashv2-panel-actmeta">
      <span title={exactTime(item.occurred_at)}>
        {relativeDay(item.occurred_at)}
      </span>
      <span className="dashv2-panel-dot" />
      <span>{item.event_type}</span>
    </div>
  </div>
);

export default ActivityItem;
